export const AtomicLogo = ({
  width = 56,
  height = 56,
}: {
  width?: number;
  height?: number;
}) => (
  <svg
    width={width}
    height={height}
    viewBox={`6 6 44 44`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="Atomic Supply Logo"
  >
    <path
      d="M45.2338 45.2294C48.9342 41.529 44.0255 30.6206 34.2697 20.8649C24.514 11.1092 13.6056 6.20038 9.9052 9.90083C6.20476 13.6013 11.1135 24.5096 20.8692 34.2654C30.625 44.0211 41.5333 48.9298 45.2338 45.2294Z"
      stroke="#3877F7"
      strokeWidth="3.44567"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M34.2697 34.2657C44.0255 24.51 48.9342 13.6017 45.2338 9.90122C41.5333 6.20077 30.625 11.1095 20.8692 20.8653C11.1135 30.621 6.20476 41.5293 9.9052 45.2298C13.6056 48.9302 24.514 44.0215 34.2697 34.2657Z"
      stroke="#3877F7"
      strokeWidth="3.44567"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M27.5653 30.1495C28.9926 30.1495 30.1496 28.9924 30.1496 27.5652C30.1496 26.138 28.9926 24.981 27.5653 24.981C26.1381 24.981 24.9811 26.138 24.9811 27.5652C24.9811 28.9924 26.1381 30.1495 27.5653 30.1495Z"
      fill="#437EF7"
    />
  </svg>
);
